import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=8376a356"
import script from "./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateCourse.vue?vue&type=style&index=0&id=8376a356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports